module.exports = __webpack_public_path__ + "media/images/img_mansion_replacement-8c28d982e1027a27f01221e3c2f2947c.png";